export default __webpack_public_path__ + "static/media/check.562b1847.svg";